import React, { useContext } from 'react'
import cn from 'classnames'

import { LocationContext, SiteDataContext } from '../../components'
import ButtonNew from '../ButtonNew'
import { getUrl } from '@/src/utils/urls'
import { useNavigationData } from '@/src/context/NavigationContext'
import { BUTTON_VARIANT } from '../ButtonNew/ButtonNew'

const LogoGrid = ({ title = '', logos = [], classes, cta }) => {
  const { isTextRtl } = useContext(SiteDataContext)
  const location = React.useContext(LocationContext)
  const { navigationItems } = useNavigationData()
  const { slugPrefix } = location

  return (
    <section className={cn('l-section c-logo-grid', classes, { 'c-logo-grid--rtl': isTextRtl })}>
      {title && (
        <div className="c-logo-grid__title-container">
          <h2 className="c-logo-grid__title">{title}</h2>
        </div>
      )}

      <div className="l-container:12/12 c-logo-grid__container">
        <div className="c-logo-grid__images">
          {logos.map((logo) => (
            <img
              key={logo.id}
              src={typeof logo.logo === 'string' ? logo.logo : logo.url}
              title={logo.title}
              alt={logo.title}
              className="c-logo-grid__logo"
              width="72"
              height="72"
            />
          ))}
        </div>
      </div>
      {cta && (
        <div className="c-logo-grid__cta">
          <ButtonNew
            variant={BUTTON_VARIANT.GREEN}
            url={getUrl({
              navItem: cta,
              slugPrefix: slugPrefix,
              navigationItems: navigationItems
            })}
          >
            {cta.title}
          </ButtonNew>
        </div>
      )}
    </section>
  )
}

export default LogoGrid
